export var getApplicantFullName = function (targetApplicant) {
    return "".concat((targetApplicant === null || targetApplicant === void 0 ? void 0 : targetApplicant.firstName) || '').concat((targetApplicant === null || targetApplicant === void 0 ? void 0 : targetApplicant.lastName) ? " ".concat(targetApplicant.lastName) : '').trim();
};
export var isMultiApplicantsCase = function (modalApplicants, allApplicants) {
    if (modalApplicants === void 0) { modalApplicants = []; }
    if (allApplicants === void 0) { allApplicants = []; }
    var totalCount = allApplicants && allApplicants.length > 0 ? allApplicants.length : modalApplicants.length;
    return totalCount > 1;
};
export var getApplicantIndex = function (targetApplicant, modalApplicants, allApplicants) {
    if (modalApplicants === void 0) { modalApplicants = []; }
    if (allApplicants === void 0) { allApplicants = []; }
    var globalIndex = allApplicants.findIndex(function (applicant) { return applicant.id === (targetApplicant === null || targetApplicant === void 0 ? void 0 : targetApplicant.id); });
    return globalIndex !== -1 ? globalIndex : modalApplicants.findIndex(function (applicant) { return applicant.id === (targetApplicant === null || targetApplicant === void 0 ? void 0 : targetApplicant.id); });
};
export var getApplicantDisplayOption = function (targetApplicant, modalApplicants, allApplicants) {
    if (modalApplicants === void 0) { modalApplicants = []; }
    if (allApplicants === void 0) { allApplicants = []; }
    var fullName = getApplicantFullName(targetApplicant);
    var isMulti = isMultiApplicantsCase(modalApplicants, allApplicants);
    if (!isMulti) {
        return fullName;
    }
    var index = getApplicantIndex(targetApplicant, modalApplicants, allApplicants);
    return index !== -1 ? "".concat(index + 1, " - ").concat(fullName) : fullName;
};
export var getApplicantFromOption = function (selectedOption, modalApplicants, allApplicants) {
    if (modalApplicants === void 0) { modalApplicants = []; }
    if (allApplicants === void 0) { allApplicants = []; }
    return modalApplicants.find(function (modalApplicant) { return getApplicantDisplayOption(modalApplicant, modalApplicants, allApplicants) === selectedOption; });
};
